import { NotificationEngineFieldTypes } from '../../../../services/Hub/notificationCenter/types';
import { FieldDefinitionTypes } from '../../AdvancedExpressionBuilder/types';

export const FIELD_TYPE_MAPPING: Record<NotificationEngineFieldTypes, FieldDefinitionTypes> = {
  [NotificationEngineFieldTypes.address]: 'select',
  [NotificationEngineFieldTypes.text]: 'select',
  [NotificationEngineFieldTypes.boolean]: 'boolean',
  [NotificationEngineFieldTypes.currency]: 'numeric',
  [NotificationEngineFieldTypes.multiselect]: 'select',
  [NotificationEngineFieldTypes.select]: 'select',
  [NotificationEngineFieldTypes.textArea]: 'select',
  [NotificationEngineFieldTypes.date]: 'date',
  [NotificationEngineFieldTypes.numeric]: 'numeric',
  [NotificationEngineFieldTypes.file]: 'select'
};

export const OPERATORS_BY_FIELD_TYPE: Record<string, string[]> = {
  select: ['eq', 'ne', 'exists', 'in', 'nin'],
  numeric: ['eq', 'ne', 'gt', 'gte', 'lt', 'lte'],
  date: ['eq', 'ne', 'gt', 'gte', 'lt', 'lte'],
  currency: ['eq', 'ne', 'gt', 'gte', 'lt', 'lte'],
  boolean: ['eq', 'ne'],

  file: ['exists'],
  address: ['exists'],
  text: ['eq', 'ne', 'in', 'nin'],
  multiselect: ['in', 'nin'],
  textArea: ['eq', 'ne']
};
